import { useAppSelector } from '@/hooks'
import type { RootState } from '@/store'

/**
 * Whether this company reads its members and drivers from the team directory (`/team/*`): verify's
 * `featureFlags.teamDirectory`, which the server derives from the company's users cutover stage (on at `users-first` /
 * `users-only`). Off, the directory hooks answer from `application.users` instead, so every screen works at both stages
 * and turning the stage back is the rollback.
 */
export const selectTeamDirectoryEnabled = (state: RootState): boolean => state.auth.featureFlags?.teamDirectory === true

export const useTeamDirectoryEnabled = (): boolean => useAppSelector(selectTeamDirectoryEnabled)

/** The company every directory cache entry is keyed by; undefined before the first verify. */
export const selectTeamApplicationId = (state: RootState): string | undefined => (state.auth.application?.id ? String(state.auth.application.id) : undefined)
